// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","9630":"6d25c37e"}[chunkId] + ".chunk.css";
};